import React, { createContext, useContext, useState, useEffect, ReactNode } from 'react';

// Legacy board types removed - only intelliSpace remains
export type AppMode = 'intelliSpace';

interface AppModeContextType {
  mode: AppMode;
  setMode: (mode: AppMode) => void;
  toggleMode: () => void;  // Kept for backward compatibility
}

const AppModeContext = createContext<AppModeContextType | undefined>(undefined);

export const AppModeProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  // Fixed to intelliSpace mode only
  const [mode] = useState<AppMode>('intelliSpace');

  const setMode = (_mode: AppMode) => {
    // No-op: mode is fixed to intelliSpace
    console.warn('setMode called but mode is fixed to intelliSpace');
  };

  const toggleMode = () => {
    // No-op: mode is fixed to intelliSpace
    console.warn('toggleMode called but mode is fixed to intelliSpace');
  };

  return (
    <AppModeContext.Provider value={{ mode, setMode, toggleMode }}>
      {children}
    </AppModeContext.Provider>
  );
};

export const useAppMode = () => {
  const context = useContext(AppModeContext);
  if (context === undefined) {
    throw new Error('useAppMode must be used within an AppModeProvider');
  }
  return context;
};